/* eslint-disable indent */
// Components
import AlertModal from 'components/AlertModal';
import { FormElems } from 'components';

// helpers
import { humanDate } from 'utils/helperMethods';

// Libraries
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Styles
import './settlementForm.scss';

const MINIMUM_COMMENT_LENGTH = 5;

const SettlementForm = props => {
    const {
        data,
        statusData = {},
        permissions,
        comments,
        callbackFunction,
    } = props;
    const [isShowModal, setIsShowModal] = useState(false);
    const [userComment, setUserComment] = useState(null);
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        setIsDisabled(
            userComment?.length >= MINIMUM_COMMENT_LENGTH &&
                userComment?.trim().length >= MINIMUM_COMMENT_LENGTH
                ? false
                : true
        );
    }, [userComment]);

    const retrySettlementHandler = () => {
        props.actions.retrySettlementRequest({
            executionIds: [data.settlementId],
        });
    };

    const repeatSettlementHandler = () => {
        setIsShowModal(true);
    };

    const onSuccessModal = () => {
        setIsShowModal(false);
        props.actions.retriggerSettlementRequest({
            executionId: data.settlementId,
            remarks: userComment,
        });
        callbackFunction();
    };

    return (
        <form className="settlement-view">
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Settlement ID</p>
                    <p className="user-text">{data.settlementId}</p>
                </div>
                <div className="form-field">
                    <p className="label">UTR</p>
                    <p className="user-text">{data.utr}</p>
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Date Time</p>
                    <p className="user-text">{data.date}</p>
                </div>
            </div>

            <div className="form-section">
                <div className="form-field">
                    <p className="label">Gross Amount</p>
                    <p className="user-text">{data.grossAmt}</p>
                </div>
                <div className="form-field">
                    <p className="label">Refund Amount</p>
                    <p className="user-text">{data.refundAmt}</p>
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Fee & Charges</p>
                    <p className="user-text">{data.fee}</p>
                </div>
                <div className="form-field">
                    <p className="label">GST</p>
                    <p className="user-text">{data.gst}</p>
                </div>
            </div>

            <div className="form-section">
                <div className="form-field">
                    <p className="label">Status</p>
                    <p
                        className={`user-text status ${statusData.settlementStatus ||
                        data.settlementStatus}`}
                    >
                        {statusData.settlementStatus || data.settlementStatus}
                    </p>
                </div>
                <div className="form-field">
                    <p className="label">Net Settlement Amount</p>
                    <p className="user-text">{data.netSettlementAmount}</p>
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Settlement Mode</p>
                    <p className="user-text">{data.originalData.settlementMode}</p>
                </div>
                <div className="form-field">
                    <p className="label">Settlement Type</p>
                    <p className="user-text">{data.originalData.settlementType}</p>
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Payment Mode</p>
                    <p className="user-text">{data.originalData.paymentMode}</p>
                </div>
            </div>

            {data.settlementStatus === 'SETTLED' &&
                permissions.view_settlement.includes('repeat_settlement') && (
                    <>
                        <div className="form-section">
                            <FormElems.TextArea
                                handleChange={value => setUserComment(value)}
                                placeholder="Please enter your comment"
                                isRequired
                            />
                        </div>
                        <div className="form-section">
                            <div
                                className={`retry-settlement ${
                                    isDisabled ? 'disabled' : ''
                                }`}
                                onClick={
                                    isDisabled ? null : repeatSettlementHandler
                                }
                            >
                                Retrigger Settlement
                            </div>
                        </div>
                    </>
                )}

            {data.settlementStatus !== 'SETTLED' &&
                props.userLevel === 'ADMIN' && (
                    <div className="form-section">
                        <div
                            className="retry-settlement"
                            onClick={retrySettlementHandler}
                        >
                            Retry Settlement
                        </div>
                    </div>
                )}

            {comments && comments.length > 0 ? (
                <div className="comments-main-container">
                    <div className="comments-main-title">Comment History</div>
                    {comments.map((comment, index) => {
                        return (
                            <div key={index} className="comment-container">
                                <div className="comment-message-box">
                                    {comment.remarks}
                                </div>
                                <div className="comment-bottom-box">
                                    <div className="comment-user">
                                        {comment.userId}
                                    </div>
                                    <div className="comment-time">
                                        {comment.timeStamp}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <></>
            )}

            <AlertModal
                modalIsOpen={isShowModal}
                closeModal={() => setIsShowModal(false)}
                primaryButtonText="OK"
                secondaryButtonText="CANCEL"
                showActions={true}
                headerText={'Attention'}
                onSuccessModal={onSuccessModal}
                message={`Are you sure that you want to repeat settlement with settlement ID ${data.settlementId} with amount ${data.grossAmt}?`}
            />
        </form>
    );
};

SettlementForm.propTypes = {
    data: PropTypes.object.isRequired,
    statusData: PropTypes.object,
    userLevel: PropTypes.string,
    fetchStatus: PropTypes.func.isRequired,
    actions: PropTypes.func.isRequired,
    fetchData: PropTypes.func.isRequired,
    permissions: PropTypes.object,
    comments: PropTypes.array,
    callbackFunction: PropTypes.func,
};

export default SettlementForm;
